import { ShortUrl } from '@air/api';
import { skipToken, useQuery } from '@tanstack/react-query';

export const LIST_CUSTOM_FIELDS_QUERY_KEY = 'list-custom-fields';

export const getShortUrlListCustomFieldsQueryKey = (params: UseShortUrlListCustomFieldsParams) => [
  LIST_CUSTOM_FIELDS_QUERY_KEY,
  params,
];

export type UseShortUrlListCustomFieldsParams = {
  shortId: string | undefined;
};

export const useShortUrlListCustomFields = ({ shortId, ...params }: UseShortUrlListCustomFieldsParams) => {
  return useQuery({
    queryKey: getShortUrlListCustomFieldsQueryKey({ shortId, ...params }),
    queryFn: !shortId
      ? skipToken
      : () => {
          return ShortUrl.listCustomFields(shortId, { ...params, limit: 100 });
        },
  });
};
